import { render } from "./join.vue?vue&type=template&id=c3614ec6&ts=true"
import script from "./join.vue?vue&type=script&lang=ts"
export * from "./join.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__